import { SessionContextProvider } from "@supabase/auth-helpers-react";
import { supabaseClient } from "./utils/supabase";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { configureStore } from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import i18n from "./helpers/i18n";

import { QueryClientProvider } from "react-query";
import { queryClient } from "./libs/react-query";
import { Toaster } from "sonner";
import "./globals.css";
import { ThemeProvider } from "./contexts/ThemeContext";
import { initKeyboardFocusDetector } from "./utils/keyboardFocusDetector";
import PostHogProviderWrapper from "./components/PostHogProviderWrapper";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

supabaseClient.auth
  .getSession()
  .then((session: any) => {
    const userData = session?.data?.session?.user;
  })
  .catch((error: any) => {
    console.error("Error retrieving session:", error);
  });

i18n.init({
  lng: "en-US",
  fallbackLng: "en-US",
});

// Enables focus outlines only when the user navigates using the keyboard (Tab key).
// Adds or removes the "user-is-tabbing" class on <body> based on whether the user is tabbing or clicking.
initKeyboardFocusDetector();

root.render(
  <ThemeProvider>
    <I18nextProvider i18n={i18n}>
      <SessionContextProvider supabaseClient={supabaseClient}>
        <QueryClientProvider client={queryClient}>
          <Provider store={configureStore({})}>
            <BrowserRouter>
              <PostHogProviderWrapper>
                <Toaster
                  richColors
                  theme="light"
                  position="top-center"
                  duration={2500}
                />
                <App />
              </PostHogProviderWrapper>
            </BrowserRouter>
          </Provider>
        </QueryClientProvider>
      </SessionContextProvider>
    </I18nextProvider>
  </ThemeProvider>
);

reportWebVitals();
